import React, { ReactNode } from 'react';
import { Breadcrumb } from 'antd';
import BreadcrumbSeparator from 'antd/lib/breadcrumb/BreadcrumbSeparator';

export type BreadcrumbSeparatorProps = Partial<typeof BreadcrumbSeparator> & {
  children?: ReactNode
};

const ProBreadcrumbSeparator: React.FC<BreadcrumbSeparatorProps> = (props) => {
  const { children, ...resProps } = props;

  return <Breadcrumb.Separator {...resProps}>{children}</Breadcrumb.Separator>;
};

export default ProBreadcrumbSeparator;
